/**
 * WomensHealthStep.validation.js
 *
 * Pure function, no React — mirrors MealScheduleStep.validation.js.
 *
 * Rules (FSD Screen 11):
 *  - At least one condition selected, or "none".
 *  - If "pregnant" is among the selected conditions: Trimester and
 *    Gestational Diabetes are both required. Due Date and Doctor-Advised
 *    Restrictions stay optional per the FSD's field table.
 */

import { NONE_OPTION_ID } from "./WomensHealthStep.constants";

export function validateWomensHealth(data) {
  const errors = {};
  const conditions = data.conditions || [];
  const isPregnant = conditions.includes("pregnant");

  if (conditions.length === 0) {
    errors.conditions = "Please select at least one option, or choose None.";
  }

  if (isPregnant) {
    if (!data.trimester) {
      errors.trimester = "Please select your trimester.";
    }
    if (data.gestationalDiabetes !== "yes" && data.gestationalDiabetes !== "no") {
      errors.gestationalDiabetes = "Please let us know about gestational diabetes.";
    }
  }

  return { isValid: Object.keys(errors).length === 0, errors };
}

// Selecting "None" clears every condition; selecting any real condition
// clears "None" — same mutual-exclusion UX as Screen 6's Medical
// Conditions field. Exported so the component's onClick handler stays a
// one-liner and the rule is unit-testable on its own.
export function toggleCondition(currentConditions, optionId) {
  if (optionId === NONE_OPTION_ID) {
    return currentConditions.includes(NONE_OPTION_ID) ? [] : [NONE_OPTION_ID];
  }

  const withoutNone = currentConditions.filter((id) => id !== NONE_OPTION_ID);
  return withoutNone.includes(optionId)
    ? withoutNone.filter((id) => id !== optionId)
    : [...withoutNone, optionId];
}
